import { ExternalLink, ShieldCheck } from "lucide-react";
import { JOTFORM_URL } from "@/lib/site";

export default function LeadForm() {
  return (
    <section
      id="request"
      data-testid="request-section"
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#0B1120] via-[#0d1428] to-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-orange-500" />
              <span className="font-tech text-orange-400 text-xs">REQUEST A CUSTOM CAMPAIGN</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl leading-[0.95] tracking-tight">
              <span className="chrome-text">Tell Us About</span>
              <br />
              <span className="ember-text">Your Campaign.</span>
            </h2>
            <p className="mt-6 font-body text-slate-400">
              Fill out our campaign requirements form. A division specialist will reach
              out within one business day to build your pipeline.
            </p>

            <div className="mt-8 forge-card p-5">
              <ShieldCheck size={20} className="text-amber-400 mb-2" />
              <div className="font-display text-base">Secure Submission</div>
              <p className="font-body text-slate-400 text-sm mt-1">
                Submissions go directly to admin@masterreadyservices.pro. We never share
                your campaign details.
              </p>
            </div>

            <a
              href={JOTFORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="jotform-external-link"
              className="mt-5 inline-flex items-center gap-2 font-tech text-xs text-amber-400 hover:text-amber-300 transition-colors"
            >
              Open form in new tab <ExternalLink size={12} />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="tracing-beam p-2">
              <div className="bg-[#0B1120]/80 p-2 md:p-3 rounded-sm">
                <iframe
                  src={JOTFORM_URL}
                  title="Campaign Requirements Form"
                  data-testid="jotform-iframe"
                  className="w-full"
                  style={{
                    minHeight: "780px",
                    height: "780px",
                    border: "0",
                    background: "transparent",
                  }}
                  allow="geolocation; microphone; camera"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
